<template>
  <div class="mobile-navbar_wrap hidden-sm-and-up">
    <div class="mobile-navbar_container">
      <div class="nav_left" @click="handleSelect('/')">
        <img src="@/assets/img/navigate/logo.png" alt="LOGO" />
      </div>
      <button class="menu_button" type="button" @click="toggleMenu">
        <i class="el-icon-menu"></i>
      </button>
    </div>

    <!-- 遮罩层：放在菜单下面，z-index 低于菜单，避免挡住菜单 -->
    <div v-if="menuOpen" class="mobile-menu_mask" @click="closeMenu"></div>

    <!-- 抽屉菜单：在遮罩之上，使用 Element UI 手风琴 -->
    <transition name="mobile-menu-slide">
      <nav v-if="menuOpen" class="mobile-menu_panel">
        <el-collapse v-model="activeCollapse" accordion class="mobile-menu_collapse">
          <el-collapse-item
            v-for="(item, index) in menuTree"
            :key="index"
            :name="String(index)"
            :class="{ 'mobile-collapse_item-leaf': !item.children || !item.children.length }"
          >
            <!-- 有二级：标题仅展开/收起 -->
            <template v-if="item.children && item.children.length" slot="title">
              <span class="mobile-menu_link" :class="{ active: isActiveRoute(item.path) }">
                {{ item.title }}
              </span>
            </template>
            <!-- 无二级：标题点击即跳转，不展开 -->
            <template v-else slot="title">
              <a
                href="javascript:void(0);"
                class="mobile-menu_link mobile-menu_link_anchor"
                :class="{ active: isActiveRoute(item.path) }"
                @click.prevent="handleSelect(item.path)"
              >
                {{ item.title }}
              </a>
            </template>
            <!-- 二级列表（仅有一级有 children 时渲染） -->
            <ul v-if="item.children && item.children.length" class="mobile-submenu_list">
              <li
                v-for="(child, childIndex) in item.children"
                :key="childIndex"
                class="mobile-submenu_item"
              >
                <a
                  href="javascript:void(0);"
                  class="mobile-submenu_link"
                  :class="{ active: isActiveRoute(child.path) }"
                  @click.prevent="handleSelect(child.path)"
                >
                  {{ child.title }}
                </a>
              </li>
            </ul>
          </el-collapse-item>
        </el-collapse>
      </nav>
    </transition>
  </div>
</template>

<script>
  export default {
    data() {
      return {
                activeCollapse: '' // Element UI collapse 当前展开项（手风琴模式）
      }
    },
    computed: {
      // 与 PC 端一致：构建带完整 path 的树形菜单（只含非 hidden）
      menuTree() {
        const buildTree = (routes, parentPath = '') => {
          return routes
            .filter(route => !route.hidden)
            .map(route => {
              const fullPath = parentPath + route.path
              const title = (route.meta && route.meta.title) || ''
              const node = { path: fullPath, title }
              if (route.children && route.children.length) {
                const visibleChildren = route.children.filter(c => !c.hidden)
                if (visibleChildren.length) {
                  node.children = buildTree(route.children, fullPath + '/')
                }
              }
              return node
            })
        }
        const routes = this.$router.options.routes || []
        return buildTree(routes)
      }
    },
    methods: {
      toggleMenu() {
        this.menuOpen = !this.menuOpen
        if (!this.menuOpen) this.activeCollapse = ''
      },
      closeMenu() {
        this.menuOpen = false
        this.activeCollapse = ''
      },
      handleSelect(path) {
        if (path == null || path === '') return
        this.$router.push(path).then(() => {
          this.closeMenu()
        }).catch(() => {})
      },
      isActiveRoute(path) {
        if (!path) return false
        return this.$route.path === path || this.$route.path.startsWith(path + '/')
      }
    }
  }
</script>

<style scoped lang="scss">
  .mobile-navbar_wrap {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100%;
    background: #ffffff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  }

  .mobile-navbar_container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 56px;
    padding: 0 16px;
  }

  .nav_left img {
    height: 32px;
  }

  .menu_button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 4px;
    background: transparent;
    cursor: pointer;
    padding: 0;
  }

  .menu_button i {
    font-size: 22px;
    color: #333;
  }

  /* 遮罩：在菜单下层，仅用于点击关闭 */
  .mobile-menu_mask {
    position: fixed;
    top: 56px;
    left: 0;
    width: 100%;
    height: calc(100vh - 56px);
    background: rgba(0, 0, 0, 0.45);
    z-index: 1001;
  }

  /* 菜单面板：在遮罩之上，保证不被遮罩盖住 */
  .mobile-menu_panel {
    position: fixed;
    top: 56px;
    right: 0;
    width: 70%;
    max-width: 320px;
    height: calc(100vh - 56px);
    background: #ffffff;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
    overflow-y: auto;
    padding: 16px 0;
    z-index: 1002;
  }

  /* Element UI 手风琴：去掉边框、缩进一致 */
  .mobile-menu_collapse {
    border: none;
  }

  .mobile-menu_collapse ::v-deep .el-collapse-item__header {
    height: 48px;
    line-height: 48px;
    padding: 0 20px;
    font-size: 15px;
    color: #333;
    background: #fff;
    border: none;
  }

  .mobile-menu_collapse ::v-deep .el-collapse-item__wrap {
    border: none;
    background: #f5f7fa;
  }

  .mobile-menu_collapse ::v-deep .el-collapse-item__content {
    padding: 0;
  }

  /* 无二级的一级项：隐藏右侧箭头 */
  .mobile-menu_collapse ::v-deep .mobile-collapse_item-leaf .el-collapse-item__arrow {
    display: none;
  }

  .mobile-menu_link {
    display: block;
    font-size: 15px;
    color: #333;
    text-decoration: none;
  }

  .mobile-menu_link.active {
    color: #0555b6;
    font-weight: 500;
  }

  .mobile-menu_link_anchor:active {
    background: #f5f7fa;
  }

  .mobile-submenu_list {
    list-style: none;
    margin: 0;
    padding: 8px 0;
  }

  .mobile-submenu_item {
    padding: 0;
  }

  .mobile-submenu_link {
    display: block;
    padding: 10px 20px 10px 36px;
    font-size: 14px;
    color: #555;
    text-decoration: none;
  }

  .mobile-submenu_link.active {
    color: #0555b6;
    font-weight: 500;
  }

  .mobile-submenu_link:active {
    background: #eef1f6;
  }

  .mobile-menu-slide-enter-active,
  .mobile-menu-slide-leave-active {
    transition: transform 0.25s ease-out, opacity 0.25s ease-out;
  }

  .mobile-menu-slide-enter,
  .mobile-menu-slide-leave-to {
    transform: translateX(100%);
    opacity: 0;
  }

  @media (min-width: 769px) {
    .mobile-navbar_wrap {
      display: none;
    }
  }
</style>
